import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'fileSizeFormat',
    pure: true
})
export class FileSizeFormatPipe implements PipeTransform {
    transform(bytes: any, decimals = 2): any {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'kb', 'mb', 'gb', 'rb', 'pb', 'eb', 'zb', 'yb'];
    
        const i = Math.floor(Math.log(bytes) / Math.log(k));
    
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

}